import { render, staticRenderFns } from "./Soumission.vue?vue&type=template&id=0724b40b&scoped=true&"
import script from "./Soumission.vue?vue&type=script&lang=js&"
export * from "./Soumission.vue?vue&type=script&lang=js&"
import style0 from "./Soumission.vue?vue&type=style&index=0&id=0724b40b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724b40b",
  null
  
)

export default component.exports